__webpack_require__.p = "/ps-app/";